<app-header></app-header>
<div class="marque-text">
    <div class="animated-text d-flex justify-content-center">
        <marquee class="container" width="100%" direction="left" height="auto">
            Check out OMNI on Microsoft AppSource | OMNI is now launched for Individual users, sign up TODAY! | World’s
            Leading Conversational CX Platform Yellow.ai - now on OMNI | Orchestrate your Enterprise Automation and AI
            on OMNI- powered by Turbotic | OMNI joins hands with Soroco- Discover the power of SCOUT and data mining
        </marquee>
    </div>
</div>
<div class="first-section">
    <div class="row col text-center pt-5">
        <div class="toggle-container">
            <a class="toggle-btn" [routerLink]="['/']">
                <div class="toggle-div">
                    <span class="toggle-span">For Business</span>
                </div>
            </a>
            <a class="toggle-btn">
                <div class="toggle-div active-btn">
                    <span class="toggle-span">For Individuals</span>
                </div>
            </a>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="text-center">
                <h2 class="h2 practice-top">OMNI: Practice Top AI skills @ home, along with an industry pro</h2>
            </div>
        </div>
    </div>
</div>
<div id="top-banner-individual" class="pt-4">
    <div class="container">
        <div class="row">
            <div class="col-md-7 header-txt">
                <!-- <h1 class="mt-2">Making future engineers<br>AI-ready!</h1>
                <h4 class="h4">“Practice makes perfect”</h4>
                <h4 class="h4">With all the top AI and Automation tools available on your screen, and top industry
                    professionals as your personal coach,
                    <br>sky is the limit!
                </h4> -->
                <h2 class="txt45">Introducing OMNI Stack Developer</h2>
                <p class="f-22 text-orange">Now available in India!</p>
                <p class="f-22">Join the exclusive OMNI Developers Community</p>
                <p class="f-22">Making future engineers AI-ready!</p>
                <p class="f-22">With all the top AI & Automation tools available on your screen, and top industry professionals as your personal coach, sky is the limit!</p>
                <a (click)="scrollToElement(package_section)"
                    class="bg-button btn btn-primary flex-grow-1 bd-highlight mt-4 schedule-demo-btn text-white">Enrol
                    Now</a>
            </div>
        </div>
    </div>
</div>

<!--Main Layout-->
<section id="first-feature">
    <div class="container">
        <div class="row align-items-center my-5">
            <div class="col-md-12 text-center">
                <h2 class="h2 mb-5">Practice and Learn with experienced tech professionals</h2>
            </div>

            <div class="col-md-3 text-center">
                <div class="stats color1">
                    <h3 class="h3"><strong><span class="count1" data-from="0" data-to="35000" data-time="3000">0</span>
                            +</strong></h3>
                    <p>Engineering students across India</p>
                </div>
            </div>

            <div class="col-md-3 text-center">
                <div class="stats color2">
                    <h3 class="h3"><strong>INR <span class="count2" data-from="0" data-to="12" data-time="3500">0</span>
                            lpa</strong></h3>
                    <p>Typical salary offered to Students*</p>
                </div>
            </div>

            <div class="col-md-3 text-center">
                <div class="stats color3">
                    <h3 class="h3"><strong><span class="count3" data-from="0" data-to="50" data-time="3500">0</span>
                            +</strong></h3>
                    <p>AI, ML, NLP and RPA Pro's empaneled</p>
                </div>
            </div>

            <div class="col-md-3 text-center">
                <div class="stats color4">
                    <h3 class="h3"><strong><span class="count4" data-from="0" data-to="600" data-time="3000">0</span>
                            +</strong></h3>
                    <p>Live classes every month from OMNI for students</p>
                </div>
            </div>

        </div>
    </div>
</section>

<section class="container-fluid py-5 bg-orange">
    <div class="container">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-12 text-center">
                <h2 class="h2 mb-5" style="color:#fff;">Get Your Dream Job with the help of OMNI</h2>
            </div>

            <div class="col-md-3 text-center">
                <div class="omni-adv">
                    <img src="assets/img/img/training.png" class="img-fluid">
                    <p class="font-20 mt-2">Hands on Training</p>
                    <p class="small">Learn from Industry experts and by working on Real Life Industry Projects.</p><br>
                </div>
            </div>

            <div class="col-md-3 text-center">
                <div class="omni-adv">
                    <img src="assets/img/img/professional.png" class="img-fluid">
                    <p class="font-20 mt-2">Guided Certification</p>
                    <p class="small">Complete in-demand technology and platforms certifications, Showcase your
                        qualifications to stand out in a competitive job market.</p>
                </div>
            </div>

            <div class="col-md-3 text-center">
                <div class="omni-adv">
                    <img src="assets/img/img/internship.png" class="img-fluid">
                    <p class="font-20 mt-2">Get Industry Internship</p>
                    <p class="small">Get exposure to the real-world projects through attractive internship program for
                        selected individuals.</p>
                </div>
            </div>

            <div class="col-md-3 text-center">
                <div class="omni-adv">
                    <img src="assets/img/img/career.png" class="img-fluid">
                    <p class="font-20 mt-2">Get Ready for a Career</p>
                    <p class="small">In high-demand fields like Data Science, Artificial intelligence, Machine learning,
                        and Automation.</p>
                </div>
            </div>
            <div class="col-md-12 text-center">
                <h4 class="text-white">OMNI's hands-on practice - Narrowing the gap between Fresher and Seasoned Tech
                    Professional</h4>
            </div>
        </div>
    </div>
</section>

<section #package_section class="container-fluid py-5 bg-grey">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center">
                <h4 class="h4">Courses & Specializations</h4>
                <h2 class="h2 mb-5">Get job-ready for an In-demand Career</h2>
            </div>

            <div class="col-md-4 mb-4" *ngFor="let pack of packages">
                <div class="course-panel">
                    <div><img [src]="pack.image" class="img-fluid"></div>

                    <div class="p-3 mt-2">
                        <h4 class="h-60 overflow-hidden mb-2" [title]="pack.title">{{pack.title}}</h4>
                        <ul>
                            <li><i class="fa fa-id-card-o"></i> Level: {{pack.metadata.level}}</li>
                            <li><i class="fa fa-clock"></i> {{pack.metadata.time}}</li>
                            <li><i class="fa fa-desktop"></i> {{pack.metadata.live_project_count}} Live-Projects</li>
                            <li *ngIf="pack.certification"><i class="fa fa-file-text-o"></i> {{pack.certification}}</li>
                            <li *ngIf="pack.project"><i class="fa fa-th-list"></i> {{pack.project}}</li>
                            <li *ngIf="pack.metadata.interneship"><i class="fa fa-align-justify"></i> {{pack.metadata.interneship}}</li>
                        </ul>

                        <div class="row">
                            <div class="col-md-6">
                                <h5>{{getPackagePrice(pack) | currency:timezoneCurrency}}</h5>
                            </div>
                            <div class="col-md-6 text-right"><a (click)="getPackageInfo(pack.slug)"
                                    class="btn btn-primary bd-highlight bg-button text-white">Enrol Now</a></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<section class="container-fluid py-5">
    <div class="container  px-md-0">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center">
                <h4 class="h4">Guided Projects</h4>
                <h2 class="h2">Learn from real-world Capstone Projects</h2>
            </div>
        </div>

        <div class="body-content row">
            <div class="col p-0">
                <div class="row course-row">

                    <div class="col-md-4 text-center">
                        <div class="mycourse-card cap-project pb-2">
                            <div class="course-title">
                                <p class="font-20">Credit Card Fraud Detection through machine learning</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 text-center">
                        <div class="mycourse-card cap-project pb-2">
                            <div class="course-title">
                                <p class="font-20">Sentiment Analysis in Social Media using Machine learning and NLP</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 text-center">
                        <div class="mycourse-card cap-project pb-2">
                            <div class="course-title">
                                <p class="font-20">Product Recommendation Engine for E-Commerce website</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 text-center">
                        <div class="mycourse-card cap-project pb-2">
                            <div class="course-title">
                                <p class="font-20">Data collection through Web Scraping using RPA technologies</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 text-center">
                        <div class="mycourse-card cap-project pb-2">
                            <div class="course-title">
                                <p class="font-20">Automation of invoice processing through RPA and OCR technologies</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 text-center">
                        <div class="mycourse-card cap-project pb-2">
                            <div class="course-title">
                                <p class="font-20">Simple Chatbot for user query resolution</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</section>

<section class="py-5 bg-grey" style="border-bottom:2px solid #ddd;">
    <div class="container-fluid">
        <div class="col-md-12 text-center ">
            <h2 class="h2">User Stories</h2>
        </div>

        <div class="owl-carousel owl-theme mt-5">

            <div class="owl-item">
                <div class="card">
                    <img src="assets/img/img/testimonial-1.png">
                    <div class="testimonial mt-2 mb-2">I've gone through several RPA sessions. This is, by far the best
                        place to learn RPA for someone who’s new to the technology.</div>
                    <div class="name">Shivangi Sinha</div>
                </div>
            </div>

            <div class="owl-item">
                <div class="card">
                    <img src="assets/img/img/testimonial-2.png">
                    <div class="testimonial mt-2 mb-2">I didn't know what RPA was when I started and now I am working as
                        a Product test engineer. The course was really easy to understand and helpful.</div>
                    <div class="name">Kanchan Kumari</div>
                </div>
            </div>

            <div class="owl-item">
                <div class="card">
                    <img src="assets/img/img/testimonial-3.png">
                    <div class="testimonial mt-2 mb-2">Loved the overall support from the mentors during the course.
                        Highly recommended for someone who wants to learn RPA.</div>
                    <div class="name">Abhisekh Srivastava</div>
                </div>
            </div>

            <div class="owl-item">
                <div class="card">
                    <img src="assets/img/img/testimonial-4.png">
                    <div class="testimonial mt-2 mb-2">The course gave me a very good overview of RPA and for my
                        organization. OMNI is a must-have resource for learning and practicing RPA tools.</div>
                    <div class="name">Maniraj Balakrishnan</div>
                </div>
            </div>

            <div class="owl-item">
                <div class="card">
                    <img src="assets/img/img/testimonial-5.png">
                    <div class="testimonial mt-2 mb-2">Excellent platform for learning AI tools. OMNI provides tons of
                        easy-to-understand resources for learning RPA skills.</div>
                    <div class="name">Aarav Ghosh</div>
                </div>
            </div>

        </div>
    </div>
</section>



<app-footer></app-footer>